import { useQuery, UseQueryResult } from 'react-query';
import { PayRate } from 'types';
import { client } from 'utils/api-client';

function usePayRate(payRateId: string | undefined): UseQueryResult<{ data: PayRate }> {
  return useQuery(['payRates', payRateId], () => client.get(`pay-rates/${payRateId}/`), {
    enabled: !!payRateId,
  });
}

export default usePayRate;
